import { ResetPasswordRequestData, SaveNewPasswordData, SignInCredentials, ValidateCodeData } from '../interfaces';
import AuthResource from '../resource/AuthResource';

export default class AuthServices {
  static login(data: SignInCredentials) {
    return AuthResource.login(data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

  static postResetPassword(data: ResetPasswordRequestData) {
    return AuthResource.postResetPassword(data);
  }

  static getValidatePasswordResetLink(emailHash: string, pwdHash: string) {
    return AuthResource.getValidatePasswordResetLink(emailHash, pwdHash).then((response) => response.data);
  }

  static getValidateCodeIsValid(data: ValidateCodeData) {
    return AuthResource.getValidateCodeIsValid(data).then((response) => response.data);
  }

  static putSaveNewPassword(data: SaveNewPasswordData) {
    return AuthResource.putSaveNewPassword(data).then((response) => response.data);
  }
}
